import { render } from "./FixturesVue.vue?vue&type=template&id=20bdb7a4"
import script from "./FixturesVue.vue?vue&type=script&lang=js"
export * from "./FixturesVue.vue?vue&type=script&lang=js"

import "./FixturesVue.vue?vue&type=style&index=0&id=20bdb7a4&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__